class Accordion {
  constructor(container) {
    this.container = container;
    this.headers = this.container.querySelectorAll('dt');
  }

  init() {
    for (let header of this.headers) {
      const content = header.nextElementSibling;
      const focusableEls = content.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
      );

      for (let el of focusableEls) {
        el.setAttribute('tabindex', '-1');
      }

      header.addEventListener('click', () => {
        const contentHeight = content.scrollHeight;
        const isOpen = header.classList.contains('js-open');
        const readMoreText = header.querySelector(
          '.numbered-accordion__read-more-text'
        );
        const button = header.querySelector('button');

        // close all others
        for (let otherHeader of this.headers) {
          const otherContent = otherHeader.nextElementSibling;
          //otherContent.style.maxHeight = 0;
          otherContent.style.display = `none`;
          otherHeader.classList.remove('js-open');
          const otherReadMoreText = otherHeader.querySelector(
            '.numbered-accordion__read-more-text'
          );
          const otherButton = otherHeader.querySelector('button');

          otherButton.setAttribute('aria-expanded', 'false');

          const otherFocusableEls = otherContent.querySelectorAll(
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
          );

          for (let otherEl of otherFocusableEls) {
            otherEl.setAttribute('tabindex', '-1');
          }

          if (otherReadMoreText) {
            otherReadMoreText.innerText = 'Read more';
          }
        }

        if (!isOpen) {
          for (let el of focusableEls) {
            el.removeAttribute('tabindex');
          }
          //content.style.maxHeight = `${contentHeight}px`;
          content.style.display = `block`;
          header.classList.add('js-open');
          button.setAttribute('aria-expanded', 'true');
          if (readMoreText) {
            readMoreText.innerText = 'Read less';
          }
        } else {
          for (let el of focusableEls) {
            el.setAttribute('tabindex', '-1');
          }
          //content.style.maxHeight = 0;
          content.style.display = `none`;
          header.classList.remove('js-open');
          button.setAttribute('aria-expanded', 'false');
          if (readMoreText) {
            readMoreText.innerText = 'Read more';
          }
        }
      });
    }
  }
}

export default Accordion;
